import React, { FC } from 'react'

import { Button, Props } from './Button'

/** @deprecated - See {@link Button} */
export const TertiaryButton: FC<Props> = props => {
  return <Button {...props} bg='orange-dark-100' color='white' />
}
